import { render } from "./Healthie.vue?vue&type=template&id=1a6e5f42&scoped=true"
import script from "./Healthie.vue?vue&type=script&lang=js"
export * from "./Healthie.vue?vue&type=script&lang=js"

import "./Healthie.vue?vue&type=style&index=0&id=1a6e5f42&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\nicol\\Code\\portfolio_new\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a6e5f42"]])

export default __exports__